import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Popover, Typography } from '@mui/material';
import React, { useCallback, useState } from 'react';
import { BaseEdge, getBezierPath } from 'reactflow';

const CustomEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  markerEnd,
  selected,
}) => {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const [anchorEl, setAnchorEl] = useState(null);

  const handleEdgeClick = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = useCallback(() => {
    if (data?.onDelete && data?.targetDeployStatus === 'NOT_DEPLOYED') {
      data.onDelete(id);
    }
    handleClose();
  }, [data, id]);

  const open = Boolean(anchorEl);
  const connectionType = data?.connectionType || 'connection';
  const targetDeployStatus = data?.targetDeployStatus || 'NOT_DEPLOYED';
  const canDelete = targetDeployStatus === 'NOT_DEPLOYED';

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        interactionWidth={24}
        style={{
          stroke: selected ? '#1a37f0' : '#b1b1b7',
          strokeWidth: selected ? 3 : 2,
        }}
      />
      <path
        d={edgePath}
        fill="none"
        stroke="transparent"
        strokeWidth={24}
        className="react-flow__edge-interaction"
        onClick={handleEdgeClick}
      />
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Typography sx={{ p: 2 }}>Connection: {connectionType}</Typography>
        <Button
          startIcon={<DeleteIcon />}
          onClick={handleDelete}
          disabled={!canDelete}
          sx={{ m: 1 }}
        >
          Delete Connection
        </Button>
        {!canDelete && (
          <Typography variant="caption" color="error" sx={{ p: 1, display: 'block' }}>
            Destroy the downstream package first, or press Delete after selecting
            an undeployed connection.
          </Typography>
        )}
      </Popover>
    </>
  );
};

export default CustomEdge;
